import { post } from './base/index';
import { API } from '../helpers';

export default {
  login: (email, password) => post(`${API}/signin/`, { email, password }),
};
